export class TravisAvailabilityRequest {

  constructor(public locationId: string,
              public arrivalTime: string,
              public departureTime: string,
              public locationZone: string) {
  }

}
